import React from "react";
import { Link } from "react-router-dom";
import { LOGO } from "../lib/api";

export const PublicPage = ({ title, children, testid }) => (
  <div className="min-h-screen py-8 px-3 sm:px-6" data-testid={testid}>
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="inline-flex items-center gap-2 mb-4" data-testid="public-home-link">
        <img src={LOGO} alt="Spotter" className="h-12 w-auto drop-shadow" />
      </Link>
      <div className="bg-spotter-cream border-4 border-black rounded-2xl p-5 sm:p-8 brand-shadow">
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-spotter-maroon mb-4">{title}</h1>
        <div className="prose-spotter text-spotter-maroon space-y-3 text-[15px] leading-relaxed">{children}</div>
      </div>
      <footer className="text-center py-6">
        <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-black/70 text-spotter-cream rounded-full px-5 py-2 font-heading text-sm">
          <span>© 2026 Spotter</span>
          <span className="opacity-50">·</span>
          <Link to="/terms" className="underline hover:no-underline" data-testid="pub-footer-terms">Terms</Link>
          <Link to="/privacy" className="underline hover:no-underline" data-testid="pub-footer-privacy">Privacy</Link>
          <Link to="/report" className="underline hover:no-underline" data-testid="pub-footer-report">Report / DMCA</Link>
        </div>
      </footer>
    </div>
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <section className="mt-5">
    <h2 className="font-heading text-lg font-bold text-spotter-maroon mb-1">{heading}</h2>
    <div className="space-y-2">{children}</div>
  </section>
);
